export default "__VITE_ASSET__CgsBqsS$__"